import * as React from 'react';
import Resizer from 'react-image-file-resizer';
import uuid from 'react-uuid';


import ActiveStorageDirectUploader from './ActiveStorageDirectUploader';

import FileInput from './FileInput';
import PhotoUpload from './PhotoUpload';
import MobileInstructions from './MobileInstructions';

const MAX_PHOTO_SIZE = 1920; // Pixels in either dimension
const PHOTO_QUALITY = 70; // Jpeg compression

const resizeImage = (file) => new Promise(resolve => {
  Resizer.imageFileResizer(file, 
    MAX_PHOTO_SIZE, MAX_PHOTO_SIZE,'JPEG', PHOTO_QUALITY, 0,
    uri => {
      resolve(uri);
    },
    'base64'
  );
});


/* Determines whether this device is a desktop */
const isDesktop = () => {
  // Portrait is a mobile
  if(screen.width < screen.height) return false;

  // Small screens are mobiles
  if(screen.width < 800) return false;

  // That's ok for now
  return true;
}

import { Card  } from 'reactstrap';

type Props = {
  createUrl: string, 
  mobileUrl?: string,
}
class PhotoUploader extends React.Component<Props> {
  constructor(props) {
    super(props);
  }

  state = {
    uploads: [],
  }

  beginUpload = (upload) => {
    // We need to convert the resizeImage result into a blob
    fetch(upload.imageData)
      .then(res => res.blob())
      .then( blob => {
        blob.name = upload.file.name;

        const uploader = new ActiveStorageDirectUploader(blob);
        uploader.upload({
          onComplete: (railsBlob) => {
            this.completeUpload(upload, railsBlob.signed_id);
          },
          onError: (error) => {
            console.error(error);
          }, 
          onProgress: (percentComplete) => {
            this.setState({
              uploads: this.state.uploads.map( u => {
                if(u.id != upload.id) return u;
                return {
                  ...u,
                  progress: percentComplete,
                }
              })
            });
          },
        })
      });
  }

  completeUpload = (upload, blobId) => {
    console.log("Ready to create record", upload, blobId)

    let formData = new FormData();
    formData.append('photo[image]', blobId);
    //formData.append('photo[source]', 'customer');

    fetch(this.props.createUrl, {
      method: 'POST', 
      body: formData,
    })
      .then ( response => response.json() )
      .then ( json => {
        console.log(json);
        alert("Thank you, your photo has been uploaded.")
        this.setState({
          uploads: this.state.uploads.map( u => {
            if(u.id != upload.id) return u;
            return {
              ...upload,
              status: 'complete',
              progress: 100,
              token: json.token, 
            };
          })
        })
      });
  }

  handleFilesAdded = (files: FileList) => {
    [...files].map(file => {
      resizeImage(file).then( base64 =>  {
        var upload = {
          id: uuid(),
          file: file, 
          imageData: base64,
          status: 'uploading',
          progress: 0,
        }

        this.beginUpload(upload);

        this.setState({
          uploads: [
            ...this.state.uploads,
            upload,
          ]
        })
      })
    });
  }

  handleRemoveFile = (token) => {
    fetch(`/photos/${token}`, {
      method: 'DELETE',
    })
    this.setState({
      uploads: this.state.uploads.filter( upload => upload.token != token ),
    })
  }

  renderMobileInstructions() {
    const { mobileUrl } = this.props;
    if(!mobileUrl) return null;
    if(!isDesktop()) return null;

    return (
      <MobileInstructions url={mobileUrl} />
    );
  }

  render() {
    const { uploads } = this.state;
    const hasUploads = uploads.length > 0;

    return(
      <Card body={true}>
        <div className="d-flex">
          {this.renderMobileInstructions()}
          <div className="flex-fill d-flex flex-column">
            <Card body={true} style={{ backgroundColor: '#f4f4f4', borderColor: '#ccc', borderWidth: 1 }}>
              {!hasUploads && (
                <p className="p-5 text-center lead text-muted">
                  No photos added yet</p>)} 

                <div className="row">
                  {this.state.uploads.map( upload => 
                  <PhotoUpload {...upload} key={upload.id} 
                    onRemove={ () => this.handleRemoveFile(upload.token)} />
                )}
                </div>
            </Card>

            <FileInput 
              more={hasUploads}
              onFilesAdded={this.handleFilesAdded} /> 
          </div>
        </div>
      </Card>
    );
  }
}
export default PhotoUploader;
